import React from 'react';
import { type PropsWithChildren } from 'react';

import SwitchCase from 'components/Common/SwitchCase';
import type { NavigateProps } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { generateStorage } from 'shared/lib';

const AdminRequired = ({
  children,
  to = '/',
  state,
  relative,
}: PropsWithChildren<Omit<NavigateProps, 'to'> & { to?: NavigateProps['to'] }>) => {
  const safeLoginStorage = generateStorage();
  const isAdmin = safeLoginStorage.get('admin') === 'true';
  return (
    <SwitchCase
      value={isAdmin}
      caseBy={{
        true: <>{children}</>,
        false: <Navigate to={to} replace state={state} relative={relative} />,
      }}
    />
  );
};

export default AdminRequired;
